
import "./style.scss";
import GameTargetPicker from "./GameTargetPicker";


export default GameTargetPicker;